<div class="container justify-content-center align-items-center p-4">
    <div class="row">
        <div class="col-12">
            <h1 class="mb-1">Set up your call flow</h1>
            <h4>Define the script that your agent will follow</h4>
        </div>
    </div>
    <div class="row">
        <div class="container d-flex justify-content-end mb-1">
            <div class="row">
                <div class="col-7 p-0">
                    <button type="button" class="m-2" (click)="toggleTestAI()" mat-raised-button>Test Chatbot</button>
                </div>
                <!-- Test Assistant -->
                <div class="col-5 p-0">
                    <app-test-assistant [aiAgent]="aiAgent"></app-test-assistant>
                </div>
            </div>
        </div>

    </div>
    <div class="row">
        <!-- GRAPH -->
        <div class="col-8 mat-elevation-z2 rounded h-auto" #graphDiv>
            <ngx-graph [view]="[graphWidth, graphHeight]" [links]="links" [nodes]="nodes" [layout]="layout"
                [nodeWidth]="175" [curve]="curve" [nodeHeight]="120" [layoutSettings]="layoutSettings"
                [autoZoom]="false" [autoCenter]="false" [draggingEnabled]="false" [enableZoom]="true"
                style="background-color: gray;" [panningEnabled]="true" [panOffsetX]="800">
                <!-- Add first action button -->
                <svg:g (click)="addQuestionNode()" class="button" *ngIf="nodes.length == 0">
                    <svg:rect [attr.x]="addActionButtonX" [attr.y]="addActionButtonY" [attr.width]="120"
                        [attr.height]="40" rx="5" fill="#007bff" />
                    <svg:text [attr.x]="addActionButtonX + 60" [attr.y]="addActionButtonY + 20" fill="white"
                        font-size="14px" text-anchor="middle" dominant-baseline="middle">
                        Add Action
                    </svg:text>
                </svg:g>

                <ng-template #defsTemplate>
                    <svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4"
                        orient="auto">
                        <svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
                    </svg:marker>
                </ng-template>

                <ng-template #nodeTemplate let-node>
                    <svg:g class="node">
                        <svg:rect [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
                            [attr.fill]="'#FFFFFF'" rx="5" ry="5" stroke="#000000" stroke-width="0.5" />
                        <svg:text alignment-baseline="top">
                            <svg:tspan [attr.x]="node.dimension.width / 2" dy="1.5em" style="font-weight: bold"
                                text-anchor="middle">
                                {{node.label}}
                            </svg:tspan>
                        </svg:text>
                        <svg:text alignment-baseline="top">
                            <svg:tspan x="3" y="20" dy="1.5em" style="font-weight: bold; font-size: x-small;">
                                {{node.data.preview1}}
                            </svg:tspan>
                        </svg:text>
                        <svg:text alignment-baseline="top">
                            <svg:tspan x="3" y="32" dy="1.5em" style="font-weight: bold; font-size: x-small;">
                                {{node.data.preview2}}
                            </svg:tspan>
                        </svg:text>

                        <!-- delete node button -->
                        <svg:g class="button" (click)="onNodeDelete(node.id)">
                            <svg:rect [attr.x]="node.dimension.width - 25" y="6" width="20" height="20" rx="5"
                                fill="#EA3323" />
                            <svg:image [attr.x]="node.dimension.width - 22.5" y="8" width="15" height="15"
                                href="assets/icons/delete.svg" />
                        </svg:g>

                        <!-- add node button -->
                        <svg:g class="button" (click)="onAddChildNodeCreationForm(node)">
                            <svg:rect x="5" [attr.y]="node.dimension.height - 35" width="30" height="30" rx="5"
                                fill="#007bff" />
                            <svg:image x="5" [attr.y]="node.dimension.height - 35" width="30" height="30"
                                href="assets/icons/add.svg" />
                        </svg:g>

                        <!-- Edit node button -->
                        <svg:g class="button" (click)="onEditNodeCreationForm(node)">
                            <svg:rect [attr.x]="node.dimension.width - 35" [attr.y]="node.dimension.height - 35"
                                width="30" height="30" rx="5" fill="#007bff" />
                            <svg:image [attr.x]="node.dimension.width - 32" [attr.y]="node.dimension.height - 32"
                                width="25" height="25" href="assets/icons/edit.svg" />
                        </svg:g>
                    </svg:g>

                </ng-template>

                <ng-template #linkTemplate let-link>
                    <svg:g class="edge">
                        <svg:path class="line" stroke-width="2" marker-end="url(#arrow)"></svg:path>

                    </svg:g>
                    <svg:g class="linkMidpoint" *ngIf="link.midPoint"
                        [attr.transform]="'translate(' + (link.midPoint.x) + ',' + (link.midPoint.y) + ')'">
                    </svg:g>
                </ng-template>
            </ngx-graph>
        </div>

        <!-- QUESTION NODE FORM -->
        <div class="col-4" [hidden]="chatbotBeingTested">
            <div class="mat-elevation-z2 rounded h-100 p-2">
                <div *ngIf="!nodeQuestionForm">
                    <h1 class="text-center fw-light">Click add to create a step</h1>
                </div>

                <!-- Node creation component -->
                <form *ngIf="nodeQuestionForm" [formGroup]="nodeQuestionForm" (ngSubmit)="onNodeCreationSubmit()">
                    <h1 class="text-center mb-0">Set up your step</h1>

                    <mat-divider class="mt-3 mb-4"></mat-divider>

                    <mat-form-field appearance="outline" class="w-100 mb-4">
                        <mat-label>Name</mat-label>
                        <input id="inputName" matInput placeholder="Ex. emailcollect" formControlName="name">
                        <mat-hint>Name your step</mat-hint>
                        <mat-error *ngIf="nodeQuestionForm.controls['name'].hasError('required')">Value cannot be
                            empty</mat-error>
                        <mat-error *ngIf="nodeQuestionForm.controls['name'].hasError('maxlength')">Must be between 1
                            and 15 letters</mat-error>
                    </mat-form-field>

                    <!-- CONDITIONS -->
                    <ng-container formArrayName="conditionsArray">
                        <ng-container *ngFor="let condition of conditionsArray.controls">
                            <ng-container [formGroup]="condition">
                                <mat-form-field appearance="outline" class="w-100 mb-5">
                                    <mat-label>Condition</mat-label>
                                    <textarea rows="3" matInput placeholder="Ex. If the user says yes"
                                        formControlName="condition" required>
                                    </textarea>
                                    <mat-hint>Enter the condition that must be met to reach this step.
                                        This condition is connected to the step <span
                                            class="fw-bold">{{condition.controls['parentName'].value}}</span>
                                    </mat-hint>
                                </mat-form-field>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <mat-form-field appearance="outline" class="w-100 mb-4">
                        <mat-label>Prompt</mat-label>
                        <mat-error>You need to enter a prompt</mat-error>
                        <textarea rows="6" placeholder="Ex: Ask the user how long they have been in business" matInput
                            formControlName="directive" required></textarea>
                        <mat-hint>
                            Enter the directive that your assistant must follow.
                            {{aiAgent.agentType =='OUTBOUND' ? 'Add variables with curly brackets : {variable}':'' }}
                        </mat-hint>
                    </mat-form-field>

                    <mat-checkbox formControlName="isScheduling" class="mt-3">Should the agent book a meeting in this step
                        ?</mat-checkbox>


                    <!-- CONNECT CHILDREN COMPONENT -->
                    <ng-container *ngIf="isNodeBeingEdited">
                        <mat-divider class="mt-3 mb-3"></mat-divider>

                        <div class="d-flex flex-column justify-content-center container">
                            <h1>Children:</h1>
                            <div class="mat-elevation-z2 mb-1 p-2 rounded row"
                                *ngFor="let child of childrenOfSelectedNode; let i = index">
                                <div class="col-10">
                                    <div>
                                        <h2 class="mb-0">Name:</h2>
                                        <p>{{child.name}}</p>
                                    </div>
                                    <div>
                                        <h2 class="mb-0">Condition:</h2>
                                        <p>{{child.condition}}</p>
                                    </div>
                                    <div>
                                        <h2 class="mb-0">Directive:</h2>
                                        <p>{{child.directive}}</p>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <button type="button" mat-mini-fab class="bg-danger" [disabled]="isLoading"
                                        (click)="disconnectParentFromChild(child.id)">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <button type="button" mat-raised-button class="mt-3" (click)="onConnectChild()">
                                Connect child
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </ng-container>

                    <!-- ADD ACTIONS COMPONENT -->
                     <ng-container *ngIf="isNodeBeingEdited">
                        <mat-divider class="mt-3 mb-3"></mat-divider>

                        <div class="d-flex flex-column justify-content-center container">
                            <h1>Actions:</h1>
                            <div class="mat-elevation-z2 mb-1 p-2 rounded row"
                                *ngFor="let integration of integrationsOfSelectedNode; let i = index">
                                <div class="col-8 d-flex justify-content-between">
                                    <div>
                                        <h2 class="mb-0">Type:</h2>
                                        <mat-icon style="width: 60%;" [svgIcon]="integration.icon"></mat-icon>
                                    </div>
                                    <div>
                                        <h2 class="mb-0">Name:</h2>
                                        <p>{{integration.name}}</p>
                                    </div>
                                </div>
                                <div class="col-4 d-flex justify-content-end">
                                    <button type="button" mat-mini-fab class="bg-danger" [disabled]="isLoading"
                                        (click)="integration.removeCallBack()">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <button type="button" mat-raised-button class="mt-3" (click)="onConnectActionClicked()">
                                Connect Action
                                <mat-icon>add</mat-icon>
                            </button>
                        </div>
                     </ng-container>


                    <mat-divider class="mt-3 mb-3"></mat-divider>


                    <div class="d-flex justify-content-center align-items-center">
                        <button [disabled]="isLoading" mat-raised-button class="w-100 m-1"
                            (click)="onNodeCreationCancel()">Cancel</button>
                        <button mat-raised-button color="primary" class="w-100 m-1"
                            [disabled]="!nodeQuestionForm.valid || isLoading">
                            <span *ngIf="!isLoading">
                                Save
                            </span>
                            <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3"
                                class="mx-auto mat-spinner"></mat-spinner>
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-4" [hidden]="!chatbotBeingTested">
            <app-chatbot [aiAgentId]="aiAgent.id"></app-chatbot>
        </div>
    </div>
</div>